import { useMutation } from "@tanstack/react-query";
import { apiCrudBuilder, baseUrl } from "components/shared/apiCrudBuilder";
import { AuthenticationContext } from "components/context/AuthenticationProvider";
import { useContext } from "react";

const path = `${baseUrl}/account`;

export const { useGetAll: useAllAccount } = apiCrudBuilder(path, "Account");

export const useUpdateAccount = (options) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useMutation({
    ...options,
    mutationFn: (data) =>
      appAxios.post(`${path}/update_account/`, data).then((res) => res),
  });
};

export const useGenerateLongLiveToken = (options) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useMutation({
    ...options,
    mutationFn: () =>
      appAxios
        .post(`${baseUrl}/generate_long_live_token/`)
        .then((res) => res.data),
  });
};
